@for (items of data; track items) {
  <div class="mb-2 mx-2 row" id="tabularList">
    @for (item of items; track item) {
      <div class="list-item d-inline col-md-{{ item.span }}">
        @if (item.item !== null) {
          <span ngClass="{{ item.styleClass }}">
            {{ item.item }}
          </span>
        }
      </div>
    }
  </div>
}
